<template lang="pug">
  .marker(
    v-show="project.currentState"
    @click="goToMap(project)"
    @mouseover="$emit('mouseover')"
    @mouseout="$emit('mouseout')"
  )

</template>

<script>
import { mapActions } from 'vuex'
import Popover from './Popover'
import colorPropertyMixin from '@/mixins/color-property.js'

export default {

  props: ['project', 'showPopover'],

  components: { Popover },

  mixins: [colorPropertyMixin],

  methods: {
    ...mapActions([
      'setProjectInfoAndUpdateRoute'
    ]),

    goToMap (projectInfo) {
      this.setProjectInfoAndUpdateRoute({ projectInfo })
    }
  },

  computed: {
    popoverClasses () {
      return `${this.project.markerType}`
    }
  }

}

</script>
<style scoped lang="stylus">
@import '~@/styles/variables'

.marker
  position: absolute
  cursor: pointer
  font-size: 360%
  user-select: none
  height: 6%
  width: 3.3%
  &:hover
    text-decoration: none;

</style>
